import Navbar from "../../components/organisms/Navbar/Navbar";
import Hero from "../../components/organisms/Hero/Hero";
import MapPreviewSection from "../../components/organisms/MapPreviewSection/MapPreviewSection";
import PrecisionSection from "../../components/organisms/PrecisionSection/PrecisionSection";
import VigilanceSection from "../../components/organisms/VigilanceSection/VigilanceSection";
import CitizenSection from "../../components/organisms/CitizenSection/CitizenSection";
import ProfessionalsSection from "../../components/organisms/ProfessionalsSection/ProfessionalsSection";
import AlertsBanner from "../../components/organisms/AlertsBanner/AlertsBanner";
import AboutSection from "../../components/organisms/AboutSection/AboutSection";
import Footer from "../../components/organisms/Footer/Footer";

const LandingTemplate = ({ onRequestAccess, onSubscribeAlerts }) => (
  <>
    <Navbar onRequestAccess={onRequestAccess} />
    <Hero />
    {/* <MapPreviewSection /> */}
    <PrecisionSection />
    <VigilanceSection />
    <CitizenSection />
    <ProfessionalsSection />
    <AlertsBanner onSubscribeAlerts={onSubscribeAlerts} />
    <AboutSection />
    <Footer />
  </>
);

export default LandingTemplate;
